var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarterSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "canape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4BE8E",
    d: "M266.672,10.677v-0.008c0-5.891-4.781-10.664-10.672-10.664s-10.672,4.773-10.672,10.664v0.008v490.631   v0.016c0,5.891,4.781,10.672,10.672,10.672s10.672-4.781,10.672-10.672v-0.016V10.677z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.002,
    y: 362.654,
    fill: "#FECD57",
    width: 191.996,
    height: 106.67
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.671,
    y: 362.654,
    fill: "#FFFFFF",
    width: 21.327,
    height: 106.67
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9ED36A",
    d: "M345.623,320.904L345.623,320.904c-0.016-0.016-0.046-0.031-0.077-0.047   c-0.047-0.016-0.078-0.031-0.109-0.047c-3.5-1.499-45.562-18.671-93.312-0.094c-40.327,15.703-76.827,0.312-77.202,0.156l0,0   c-1.297-0.562-2.734-0.875-4.25-0.875c-5.89,0-10.671,4.781-10.671,10.656c0,4.375,2.625,8.125,6.375,9.766v0.016   c0.016,0,0.046,0.016,0.078,0.031c0.031,0,0.078,0.031,0.109,0.031c2.297,1,21.094,8.688,47.171,8.688   c13.796,0,29.624-2.156,46.14-8.594c40.327-15.688,76.827-0.312,77.171-0.156v-0.016c1.312,0.578,2.766,0.906,4.281,0.906   c5.89,0,10.671-4.766,10.671-10.672C351.998,326.295,349.373,322.561,345.623,320.904z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5BA45",
    d: "M224,405.325c0,5.891-4.781,10.672-10.671,10.672c-5.891,0-10.656-4.781-10.656-10.672   s4.766-10.672,10.656-10.672C219.219,394.653,224,399.435,224,405.325z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5BA45",
    d: "M266.672,426.652c0,5.906-4.781,10.672-10.672,10.672s-10.672-4.766-10.672-10.672   c0-5.875,4.781-10.655,10.672-10.655S266.672,420.777,266.672,426.652z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5BA45",
    d: "M309.327,405.325c0,5.891-4.766,10.672-10.656,10.672s-10.672-4.781-10.672-10.672   s4.781-10.672,10.672-10.672S309.327,399.435,309.327,405.325z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#965353",
    d: "M319.999,234.664H192.001c-17.671,0-31.999,14.328-31.999,32c0,17.679,14.328,31.991,31.999,31.991    h127.998c17.672,0,31.999-14.312,31.999-31.991C351.998,248.992,337.671,234.664,319.999,234.664z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M319.999,234.664h-21.328c17.672,0,32,14.328,32,32c0,17.679-14.328,31.991-32,31.991h21.328    c17.672,0,31.999-14.312,31.999-31.991C351.998,248.992,337.671,234.664,319.999,234.664z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EC5564",
    d: "M256,128.002c-53.015,0-95.998,42.976-95.998,95.998h191.996C351.998,170.978,309.015,128.002,256,128.002    z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M256,128.002c-3.609,0-7.172,0.203-10.672,0.585c47.999,5.312,85.343,46,85.343,95.413h21.327    C351.998,170.978,309.015,128.002,256,128.002z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarterSvgrepoCom);
export default __webpack_public_path__ + "static/media/starter-svgrepo-com.d0d1474ab8c52169b5701e834010f05f.svg";
export { ForwardRef as ReactComponent };